import { render, staticRenderFns } from "./fillinlogistics.vue?vue&type=template&id=4d4ffa08&scoped=true"
import script from "./fillinlogistics.vue?vue&type=script&lang=ts"
export * from "./fillinlogistics.vue?vue&type=script&lang=ts"
import style0 from "./fillinlogistics.vue?vue&type=style&index=0&id=4d4ffa08&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d4ffa08",
  null
  
)

export default component.exports